import React, { useState, useEffect } from "react";

const TypingText = ({ textList, typingSpeed = 150, deletingSpeed = 100, pauseTime = 1000 }) => {
  const [textIndex, setTextIndex] = useState(0);
  const [displayText, setDisplayText] = useState("");
  const [isDeleting, setIsDeleting] = useState(false);

  useEffect(() => {
    const currentText = textList[textIndex];

    const updateText = () => {
      setDisplayText((prev) =>
        isDeleting
          ? currentText.substring(0, prev.length - 1) 
          : currentText.substring(0, prev.length + 1) 
      );

      if (!isDeleting && displayText === currentText) {
        setTimeout(() => setIsDeleting(true), pauseTime); 
      } else if (isDeleting && displayText === "") {
        setIsDeleting(false);
        setTextIndex((prev) => (prev + 1) % textList.length); 
      }
    };

    const timer = setTimeout(updateText, isDeleting ? deletingSpeed : typingSpeed);
    return () => clearTimeout(timer);
  }, [displayText, textIndex, isDeleting, textList, deletingSpeed, pauseTime, typingSpeed]);

  return <span className="typing-text">{displayText}<span className="animate-blink">|</span></span>;
};

export default TypingText;
